// mfaService.js

import axiosInstance, { ADMIN_BASEURL } from './axiosInstance';

// MFA API calls
export const validateEmailForMFA = async (email, accountId) => {
    try {
      const response = await axiosInstance({
        url: `mfa/validate-email?email=${encodeURIComponent(email)}&accountId=${accountId}`,
        method: 'POST',
        baseURL: ADMIN_BASEURL
      });
      
      return response.data;
    } catch (error) {
      console.error('Email validation error:', error);
      throw error;
    }
  };
  
  export const sendOTP = async (email, accountId) => {
    try {
      const response = await axiosInstance({
        url: `mfa/send-otp?email=${encodeURIComponent(email)}&accountId=${accountId}`,
        method: 'POST',
        baseURL: ADMIN_BASEURL
      });
      
      return response.data;
    } catch (error) {
      console.error('Send OTP error:', error);
      throw error;
    }
  };
  
  export const verifyOTP = async (email, otp, accountId) => {
    try {
      const response = await axiosInstance({
        url: `mfa/verify-otp?email=${encodeURIComponent(email)}&otp=${otp}&accountId=${accountId}`,
        method: 'POST',
        baseURL: ADMIN_BASEURL
      });
      
      return response.data;
    } catch (error) {
      console.error('Verify OTP error:', error);
      throw error;
    }
  };
  
  export const validateMFAToken = async (token) => {
    try {
      const response = await axiosInstance({
        url: `mfa/validate-token?token=${token}`,
        method: 'GET',
        baseURL: ADMIN_BASEURL
      });
      
      return response.data;
    } catch (error) {
      console.error('Validate token error:', error);
      throw error;
    }
  };